<template>
  <EstadoMaquinaCazels
    v-bind="$attrs"
    v-on="$listeners"
    :value="visible"
    :poll-ms="pollMs"
  />
</template>

<script>
import EstadoMaquinaCazels from "./EstadoMaquinaCazels.vue";

export default {
  name: "MaquinaEstado",
  components: {
    EstadoMaquinaCazels,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: undefined,
    },
    active: {
      type: Boolean,
      default: undefined,
    },
    pollMs: {
      type: Number,
      default: 60000,
    },
  },
  computed: {
    visible() {
      if (typeof this.active === "boolean") return this.active;
      if (typeof this.value === "boolean") return this.value;
      return true;
    },
  },
};
</script>
